import { useLang } from "@/i18n/LanguageContext";
import { Check } from "lucide-react";

const PaymentsSection = () => {
  const { t } = useLang();
  const m = t.payments.mock;
  return (
    <section className="py-24 md:py-32 bg-primary text-primary-foreground">
      <div className="container grid lg:grid-cols-2 gap-16 items-center">
        <div className="order-2 lg:order-1 relative">
          <div className="rounded-3xl bg-background text-foreground shadow-elegant p-7">
            <div className="flex items-center justify-between">
              <div className="text-sm font-bold">{m.title}</div>
              <div className="text-xs px-2 py-1 rounded-full bg-mint text-mint-foreground font-bold">{m.live}</div>
            </div>
            <div className="mt-2 text-5xl font-extrabold tracking-tight">€ 18.420,50</div>
            <div className="mt-1 text-sm text-primary-glow font-bold">{m.delta}</div>

            <div className="mt-6 space-y-3">
              {m.rows.map((r) => (
                <div key={r.who} className="flex items-center justify-between rounded-xl bg-secondary px-4 py-3">
                  <div>
                    <div className="text-sm font-bold">{r.who}</div>
                    <div className="text-xs text-muted-foreground">{r.what}</div>
                  </div>
                  <div className="text-sm font-bold">{r.amt}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <span className="text-xs font-bold uppercase tracking-[0.2em] opacity-80">{t.payments.eyebrow}</span>
          <h2 className="mt-3 text-3xl sm:text-4xl md:text-6xl font-extrabold leading-[1.05]">{t.payments.title}</h2>
          <p className="mt-5 text-lg md:text-xl opacity-85 leading-relaxed">{t.payments.desc}</p>
          <ul className="mt-8 space-y-3">
            {t.payments.bullets.map((b) => (
              <li key={b} className="flex items-start gap-3">
                <span className="mt-0.5 inline-flex h-6 w-6 items-center justify-center rounded-full bg-primary-foreground/15 shrink-0">
                  <Check className="h-3.5 w-3.5" />
                </span>
                <span>{b}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default PaymentsSection;
